"use strict";

import Axios from "axios";
import configuration from "../../configuration";

const url = configuration.apiHost + "budgets";

export default class BudgetService {
  static async getAll() {
    try {
      let alls = await Axios.get(url);
      return alls.data;
    } catch (error) {
      throw new Error(error);
    }
  }
  
  static async getAllApproved() {
    try {
      let alls = await Axios.get(`${configuration.apiHost}budgets-status/APROVADO`);
      return alls.data;
    } catch (error) {
      throw new Error(error);
    }
  }
  static async getAllApprovedToUseInContract () {
    try {
      let alls = await Axios.get(`${configuration.apiHost}budgets-status/`);
      return alls.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async findComplete(id){
    if(!id) throw new Error("BudgetService: o id deve ser fornecido ao buscar orçamento");
    try {
      let response = await Axios.get(`${configuration.apiHost}budgets-complete/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error);
    }
  }

  static async save(budget) {
    try {
      let saved = await Axios.post(url, budget);
      return saved.data;
    } catch (error) {
      throw new Error(error);
    }
  } // save()

  static async edit(budget) {
    try {
      let updated = await Axios.put(url, budget);
      return updated.data;
    } catch (error) {
      throw new Error(error);
    }
  } // edit()

  static async remove(budget) {
    try {
      await Axios.delete(url, {
        data: budget
      });
    } catch (error) {
      throw new Error(error);
    }
  } // remove()

  static async download(budgetId) {
    try {
      let resp = await Axios.get(`${url}/download/${budgetId}`, {responseType: 'blob'});
      return resp.data
    } catch (error) {
      throw new Error(error);
    }
  }

} // class



// WEBPACK FOOTER //
// ./src/service/BudgetService.js